import * as React from "react";
import { AgentInfo } from "../../../schema/types/agent";
import { sortInstances, INSTANCE_STATUS_CONFIG, InstanceStatus } from "./instanceUtils";
import { InstanceCard } from "./InstanceCard";

interface InstanceGridProps {
  agentInfo: AgentInfo[];
}

export const InstanceGrid: React.FC<InstanceGridProps> = ({ agentInfo }) => {
  const [expandedId, setExpandedId] = React.useState<string | null>(null);

  const sortedInstances = React.useMemo(() => sortInstances(agentInfo), [agentInfo]);

  const counts = React.useMemo(() => {
    const result: Record<InstanceStatus, number> = { active: 0, stale: 0, inactive: 0, never: 0 };
    for (const inst of sortedInstances) {
      result[inst.status]++;
    }
    return result;
  }, [sortedInstances]);

  const visibleStatuses = (["active", "stale", "inactive", "never"] as InstanceStatus[]).filter(
    (s) => counts[s] > 0
  );

  return (
    <div>
      {/* Summary bar */}
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        {visibleStatuses.map((status) => {
          const config = INSTANCE_STATUS_CONFIG[status];
          return (
            <span
              key={status}
              className="text-xs px-2 py-0.5 rounded-full"
              style={{ backgroundColor: config.bg, color: config.color }}
            >
              {counts[status]} {config.label.toLowerCase()}
            </span>
          );
        })}
      </div>

      {/* Grid */}
      <div
        style={{
          display: "grid",
          gap: "1rem",
          gridTemplateColumns: "repeat(auto-fill, minmax(420px, 1fr))",
        }}
      >
        {sortedInstances.map((instance) => {
          const id = instance.info.instanceId || instance.info.lastActive;
          return (
            <InstanceCard
              key={id}
              instance={instance}
              isExpanded={expandedId === id}
              onToggle={() => setExpandedId(expandedId === id ? null : id)}
            />
          );
        })}
      </div>
    </div>
  );
};
